import { useState } from "react";
import { Box } from "@mui/material";
import ModalStatisticsTabs from "./ModalStatisticsTabs.jsx";
import PhysicalActivityComponent from "../../Statistics/Physical Activity/PhysicalActivityComponent.jsx";
import ExerciseComponent from "../../Statistics/Exercise/ExerciseComponent.jsx";
import SleepComponent from "../../Statistics/Sleep/SleepComponent.jsx";
import LiquidsComponent from "../../Statistics/Liquids/LiquidsComponent.jsx";
import HeartRateComponent from "../../Statistics/HeartRate/HeartRateComponent.jsx";
import NutritionComponent from "../../Statistics/Nutrition/NutritionComponent.jsx";
import RiskComponent from "../../Statistics/Risk/RiskComponent.jsx";
import WeightComponent from "../../Statistics/Weight/WeightComponent.jsx";
import RecommendationsComponent from "../Recommendations/RecommendationsComponent.jsx"
import QuestionnaireTableComponent from "../Questionnaire/QuestionnaireTableComponent.jsx";

export default function StatisticsOfUserBox({ selectedUser, setLoading }) {
  const [tabsValue, setTabsValue] = useState(0);

  return (
    <Box sx={{ backgroundColor: "white", marginTop: 2, borderRadius: "20px" }}>
      <ModalStatisticsTabs tabsValue={tabsValue} setTabsValue={setTabsValue} />
      {tabsValue === 0 ? (
        <PhysicalActivityComponent
          tabsValue={tabsValue}
          selectedUser={selectedUser.subject_id}
          setLoading={setLoading}
        />
      ) : tabsValue === 1 ? (
        <ExerciseComponent
          tabsValue={tabsValue}
          selectedUser={selectedUser.subject_id}
          setLoading={setLoading}
        />
      ) : tabsValue === 2 ? (
        <SleepComponent
          tabsValue={tabsValue}
          selectedUser={selectedUser.subject_id}
          setLoading={setLoading}
        />
      ) : tabsValue === 3 ? (
        <LiquidsComponent
          tabsValue={tabsValue}
          selectedUser={selectedUser.subject_id}
          setLoading={setLoading}
        />
      ) : tabsValue === 4 ? (
        <HeartRateComponent
          tabsValue={tabsValue}
          selectedUser={selectedUser.subject_id}
          setLoading={setLoading}
        />
      ) : tabsValue === 5 ? (
        <NutritionComponent
          tabsValue={tabsValue}
          selectedUser={selectedUser.subject_id}
          setLoading={setLoading}
        />
      ) : tabsValue === 6 ? (
        <WeightComponent
          selectedUser={selectedUser.subject_id}
          setLoading={setLoading}
        />
      ) : tabsValue === 7 ? (
        <RiskComponent selectedUser={selectedUser} />
      ) : tabsValue === 8 ? (
        <>
          <QuestionnaireTableComponent selectedUser={selectedUser.subject_id} />
        </>
      ) : tabsValue === 9 ? (
        <RecommendationsComponent selectedUser={selectedUser.id} />
      ) : null}
    </Box>
  );
}
